var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlooIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0319 11.7637H15.5312V30.1621H18.0319V11.7637Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.818 28.1864C24.466 28.1864 22.7763 26.3172 22.7763 23.994C22.7763 21.7376 24.4524 19.8817 26.818 19.8817C29.1294 19.8817 30.7785 21.751 30.7785 23.994C30.7785 26.3172 29.1294 28.1864 26.818 28.1864ZM26.818 17.5986C23.0737 17.5986 20.2621 20.4692 20.2621 23.994C20.2621 27.5722 23.0602 30.4695 26.818 30.4695C30.5082 30.4695 33.2928 27.5722 33.2928 23.994C33.2928 20.4692 30.5217 17.5986 26.818 17.5986Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5259 28.1864C39.1738 28.1864 37.4842 26.3172 37.4842 23.994C37.4842 21.7376 39.1603 19.8817 41.5259 19.8817C43.8373 19.8817 45.4864 21.751 45.4864 23.994C45.4864 26.3172 43.8373 28.1864 41.5259 28.1864ZM41.5259 17.5986C37.7816 17.5986 34.97 20.4692 34.97 23.994C34.97 27.5722 37.7681 30.4695 41.5259 30.4695C45.2161 30.4695 48.0006 27.5722 48.0006 23.994C48.0006 20.4692 45.2296 17.5986 41.5259 17.5986Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.995C0 27.5732 2.8116 30.4705 6.55589 30.4705C8.08334 30.4705 9.43507 29.9765 10.5165 29.1487V30.0432C10.5165 32.9138 9.09714 33.9285 6.50182 33.9285L6.52885 36.2383C9.74597 36.2383 13.0036 35.1435 13.0036 29.4825V17.7064H10.6381L10.53 18.9081C9.44859 18.0936 8.08334 17.5996 6.5694 17.5996C2.8116 17.5996 0 20.4702 0 23.995ZM6.55589 28.1874C4.19036 28.1874 2.51422 26.3182 2.51422 23.995C2.51422 21.7386 4.19036 19.8827 6.55589 19.8827C8.86734 19.8827 10.5165 21.7519 10.5165 23.995C10.5165 26.3315 8.86734 28.1874 6.55589 28.1874Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlooIcon);
export default __webpack_public_path__ + "static/media/GlooIcon.206be20516b347ae01f8d6c5ad33264d.svg";
export { ForwardRef as ReactComponent };